/**
 * design-section.tsx — Phase 050 ABox properties panel's Design section.
 *
 * Wraps the D-050-04-classification Design keys for the block-type in an
 * `<InspectorSection title="Design">` and renders one `<PropertyRow>` per
 * key. Structurally identical to `content-section.tsx`; only the title and
 * the classifier function differ.
 *
 * D-050-04 — flat sections, no sub-grouping (ABox blocks have 3-10
 * properties; sub-grouping would be over-decomposed).
 */
import { InspectorSection } from '@/components/inspector'
import { getDesignKeys } from './classification'
import { PropertyRow } from './property-row'
import type { SectionProps } from './content-section'

export function DesignSection({ baseline, blockDrafts }: SectionProps) {
  const designKeys = getDesignKeys(baseline.blockType)
  if (designKeys.length === 0) return null
  return (
    <InspectorSection title="Design">
      {designKeys.map((key) => (
        <PropertyRow
          key={key}
          blockId={baseline.env.id}
          propertyKey={key}
          baselineValue={baseline.env.properties[key]}
          draftValue={blockDrafts[key]}
        />
      ))}
    </InspectorSection>
  )
}
